/**
 * @generated SignedSource<<88d0878df30ca1dd635d14b0e3f5dce5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MarkTicketNotificationReadInput = {
  notificationId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type markTicketNotificationReadMutation$variables = {
  input: MarkTicketNotificationReadInput;
};
export type markTicketNotificationReadMutation$data = {
  readonly markTicketNotificationRead: {
    readonly notification: {
      readonly id: string;
      readonly read: boolean;
    };
  } | null;
};
export type markTicketNotificationReadMutation = {
  variables: markTicketNotificationReadMutation$variables;
  response: markTicketNotificationReadMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MarkTicketNotificationReadPayload",
    "kind": "LinkedField",
    "name": "markTicketNotificationRead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TicketNotification",
        "kind": "LinkedField",
        "name": "notification",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "read",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "markTicketNotificationReadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "markTicketNotificationReadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fd38456b67bb0ec380bb4cab605dfbaa",
    "id": null,
    "metadata": {},
    "name": "markTicketNotificationReadMutation",
    "operationKind": "mutation",
    "text": "mutation markTicketNotificationReadMutation(\n  $input: MarkTicketNotificationReadInput!\n) {\n  markTicketNotificationRead(input: $input) {\n    notification {\n      id\n      read\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a8f7b62b4c1713a536e454fac055d2f";

export default node;
